var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading === false && (_vm.item == null || _vm.item.length === 0))?_c('div',{class:this.emptyName !== 'none' ? 'text-center' : ''},[_c('img',{attrs:{"src":_vm.path(),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title)+" bulunamadı.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }